import { Widget } from "fmko-ts-common";

export default class MultiLineWidget extends Widget {
    constructor(lines: string[]) {
        super();

        let text = <HTMLParagraphElement>document.createElement("p");
        for (let line of lines) {
            text.innerText += line + "\n";
        }
        this.element = text;
    }
}
